import React, { useContext } from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { useState } from "react";
import LanguageContext from "../../components/Language/LanguageContext";

const PricingMobile = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  const [isYearly, setIsYearly] = useState(true);
  const price = isYearly ? "384.000" : "480.000";
  return (
    <>
      <section className="surface-50 relative flex flex-column overflow-hidden justify-content-center align-items-center gap-6 px-4 py-8 md:px-6 lg:px-8 hidden sm:block md:block lg:hidden xl:hidden">
        <header className="flex align-items-center justify-content-center flex-column gap-2">
          {/* <h1 className="m-0 font-semibold text-lg line-height-3 text-primary-500">
            PRICING
          </h1> */}
          <h1 className="font-bold  text-900 text-center text-4xl">
            {messages.PricingJudul}
          </h1>
          {/* <p className="text-xl line-height-3 text-700 mt-0 mb-0">
            Fringilla ut morbi tincidunt augue interdum velit euismod. Non arcu
            risus quis varius quam.
          </p> */}
          <div className=" align-items-center">
            <span className="font-semibold  pricing2">
              {messages.BilledMonthlyPricing}
            </span>

            <InputSwitch
              checked={isYearly}
              onChange={(e) => setIsYearly(e.value)}
              style={{ zIndex: "998" }}
              className="pricing3"
            />
            <span className="font-semibold  prici1 text-center">
              {messages.BilledYearlyPricing}{" "}
              <span
                className="font-bold prici2"
                style={{ fontSize: "18px", color: "blue" }}
              >
                {messages.BilledSavePricing}
              </span>
            </span>
          </div>
        </header>
        <div className="flex flex-column lg:flex-row z-1 justify-content-center gap-5">
          <article
            className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2 artic"
            style={{ width: "500px" }}
          >
            <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-4 gap-5">
              <div className="flex flex-column gap-2">
                <h1 className="m-0 font-bold text-xl text-900">
                  {messages.freeJudul}
                </h1>
                {/* <p className="mt-2 mb-0 text-base text-600">
                  Scelerisque viverra mauris.
                </p> */}
              </div>
              <div className="flex align-items-center gap-2">
                <span className="font-semibold text-xl text-900">
                  <span className="text-xl"></span>Rp.0
                </span>{" "}
                <span className="text-base text-600">
                  {" "}
                  {messages.MonthPricing}
                </span>
              </div>
            </div>
            <div className="flex flex-column gap-3 border-bottom-1 surface-border pb-4">
              <h3 className="m-0 mb-2 font-semibold text-base text-900">
                {messages.PricingPlanIncludes}
              </h3>
              <div className="flex flex-column sm:flex-row w-3/4 justify-content-between gap-4">
                <ul className="list-none mt-2 mb-0 p-0">
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle mr-2 ceklis"></i>{" "}
                      {messages.pricingaddupto}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricinghazard5}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingasset}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingassign}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingdocument}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingdriver}
                    </p>
                  </li>

                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingcapture}
                    </p>
                  </li>

                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingessential}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingprocces}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingassets}
                    </p>
                  </li>

                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingstorage}
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricing3years}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <a href="https://app.smartsafetee.com/auth/login">
                <Button label={messages.freeButton} className="w-full"></Button>
              </a>
            </div>
          </article>
          <article
            className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2 artic"
            style={{
              width: "500px",
              // Pastikan card tidak melebihi ukuran layar
            }}
          >
            <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-4 gap-5">
              <div className="flex flex-column gap-2">
                <h1 className="m-0 font-bold text-xl text-900">BASIC</h1>
                {/* <p className="mt-2 mb-0 text-base text-600">
                  Eget mauris pharetra et ultrices.
                </p> */}
              </div>
              <div className="flex align-items-center gap-2">
                <span className="font-semibold text-xl text-900">
                  Rp.{price}
                </span>{" "}
                <span className="text-base text-600">/ {messages.month}</span>
              </div>
            </div>
            <div className="flex flex-column gap-3 border-bottom-1 surface-border pb-7">
              <h3 className="m-0 mb-2 font-semibold text-base text-900">
                {messages.pricingProfessional}
              </h3>
              <div className="flex flex-column sm:flex-row w-full justify-content-between gap-4">
                <ul className="list-none mt-2 mb-0 p-0">
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingunlimited}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricinghazard}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingassetslist}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingenhance}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingGain}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingpersonalized} <br />
                      {messages.pricingpersonalized2}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingtemplate}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricinginspection}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricing500gb}
                    </p>
                  </li>
                  <li>
                    <p className="mb-4 mt-0 text-600 flex align-items-center">
                      <i className="pi pi-check-circle ceklis mr-2"></i>{" "}
                      {messages.pricingevidence}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <a href="https://app.smartsafetee.com/auth/login">
                <Button label={messages.freeButton} className="w-full"></Button>
              </a>
            </div>
          </article>
        </div>
        <article className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2">
          <div className="flex flex-wrap justify-content-between align-items-center surface-border pb-4 gap-5">
            {/* Bagian Kiri */}
            <div className="flex flex-column gap-2">
              <h3 className="m-0 font-semibold text-xl text-900">
                {messages.pricingteam}
              </h3>
              <p className="mt-0 mb-0 text-semibold text-900 text-xl">
                {messages.pricingjust} {""}
                <span className="text-900 font-semibold text-xl">
                  Rp.
                  {new Intl.NumberFormat("id-ID").format(
                    isYearly ? 38400 : 48000
                  )}
                  {messages.pricing60}
                </span>
              </p>
            </div>

            {/* Bagian Kanan */}
            <div className="flex flex-column gap-2">
              <span className="font-semibold text-xl text-900">
                {messages.pricingGet}
              </span>{" "}
              <ul className="list-none mt-0 mb-0 sm:mt-2 p-0">
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i className="pi pi-check-circle ceklis mr-2"></i>
                    {messages.pricingmonth}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i className="pi pi-check-circle ceklis mr-2"></i>
                    {messages.pricingeffective}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i className="pi pi-check-circle ceklis mr-2"></i>
                    {messages.pricingreport}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i className="pi pi-check-circle ceklis mr-2"></i>
                    {messages.pricingwell}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i className="pi pi-check-circle ceklis mr-2"></i>
                    {messages.pricingMinimize}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </article>
        <div
          className="absolute top-50 w-screen"
          style={{ transform: "rotate(-6deg)" }}
        >
          <div className="h-4rem bg-primary-500"></div>
          <div className="h-4rem bg-primary-300"></div>
          <div className="h-4rem bg-primary-100"></div>
        </div>
      </section>
    </>
  );
};

export default PricingMobile;
